<div class="patient-survey-score">
  <div class="patient-survey-score__chart-container">
    <div
      [style.width]="score() + '%'"
      class="patient-survey-score__chart-bar"
    ></div>
  </div>

  <span>{{ score() }} %</span>
</div>
